module.exports = __webpack_public_path__ + "img/watch.f52852e.svg";